import { CSSProperties, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { companyStateJ } from '../../../../../services/state/CompanyStateJ';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';
import { StyledTextField, ScenarioNameFieldStyles } from '../../components/commonStyledComponents';
import { IScenarioDataModel } from '../../../../../data-models/scenario.data-model';
import { useAtomValue } from 'jotai';

interface ScenarioNameFieldProps {
  style?: CSSProperties;
}

export const ScenarioNameField: FC<ScenarioNameFieldProps> = ({ style }) => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const company = useAtomValue(companyStateJ(companyId));

  const {
    register,
    formState: { errors },
  } = useFormContext<Partial<IScenarioDataModel>>();

  if (!company) {
    return null;
  }

  return (
    <StyledTextField
      {...register('name')}
      className='read-write-input transparent'
      inputProps={{
        style: ScenarioNameFieldStyles,
      }}
      InputLabelProps={{ style: { fontSize: 34 } }}
      placeholder='Untitled'
      sx={{ borderBottom: 'none', transition: 'none' }}
      variant='standard'
      autoFocus
      error={!!errors.name}
      helperText={errors.name?.message ?? ' '}
      style={style}
    />
  );
};
